const axios = require('axios')
const gptUrl = process.env.REACT_APP_HOST_API + '/gpt'

export const analyzeTopicsInGroup = async (sessionId, groupId) => {
  try {
    const res = await axios.post(gptUrl + '/topics/' + groupId, { sessionId })
    console.log('topics:', res.data)
    return res.data
  } catch (e) {
    console.error(e)
    // throw e
  }
}

export const getAnswerCharts = async (answersInClass, questionNumber) => {
  try {
    console.log("querying chatgpt for chart answers")
    const res = await axios.post(gptUrl + '/answerCharts', { answersInClass, questionNumber })
    console.log('categories:', res.data)
    return res.data
  } catch (e) {
    console.error(e)
  }
}

export const classifyStudentIntent = async (taskDescription, studentCode, chatHistory, currentMessage, testResults) => {
  try {
    const response = await axios.post(gptUrl + '/classifyIntent', {
      taskDescription,
      studentCode,
      chatHistory,
      currentMessage,
      testResults
    })
    return response.data
  } catch (error) {
    console.error('Error classifying intent:', error)
    return { 
      questionType: "Unknown", 
      intent: "Unable to classify", 
      confidence: "low" 
    }
  }
}

/**
 * Assess a single student query + AI response exchange.
 * Returns { studentAssessment, aiAssessment }
 */
export const assessExchange = async (taskDescription, studentCode, chatHistory, studentMessage, aiResponse, testResults, context) => {
  try {
    const response = await axios.post(gptUrl + '/assessExchange', {
      taskDescription,
      studentCode,
      chatHistory,
      studentMessage,
      aiResponse,
      testResults,
      context
    })
    return response.data
  } catch (error) {
    console.error('Error assessing exchange:', error)
    return {
      studentAssessment: { queryType: "n", queryQuality: { score: 0 }, confidence: "low" },
      aiAssessment: { responseType: "Unknown", pedagogicalAlignment: { level: "Unknown" } }
    }
  }
}

/**
 * Batch-assess a full student-AI conversation.
 * Returns { studentAssessments, aiAssessments, summary }
 */
export const batchAssessConversation = async (taskDescription, conversation, codeSnapshots = null, testSnapshots = null) => {
  try {
    const response = await axios.post(gptUrl + '/assessConversation/batch', {
      taskDescription,
      conversation,
      codeSnapshots,
      testSnapshots
    })
    return response.data
  } catch (error) {
    console.error('Error batch assessing conversation:', error)
    return {
      studentAssessments: [],
      aiAssessments: [],
      summary: { totalMessages: 0 }
    }
  }
}

// Creation wizard: the student's starter code for a Python or C++ exercise - the function the
// description asks for, with an empty parameter list (backend: services/authoringService.js,
// Azure gpt-4o). Resolves to the code; throws when it fails.
// style 'class': a Python class exercise - the starter is the class line alone.
export const draftStarterCode = async ({ task, language, style }) => {
  const response = await axios.post(gptUrl + '/starter-code', { task, language, style }, { timeout: 60000 })
  const code = response.data?.code
  if (typeof code !== 'string' || !code.trim()) throw new Error('No starter code in the response')
  return code
}

// A Python class exercise's checks, drafted from the description (backend:
// authoringService.draftClassChecks). Resolves to [{ testName, check }]; throws when the AI
// call fails.
export const draftClassChecks = async ({ task, template, count, existing }) => {
  const response = await axios.post(gptUrl + '/class-checks', { task, template, count, existing }, { timeout: 60000 })
  return (Array.isArray(response.data?.checks) ? response.data.checks : [])
    .filter((item) => typeof item?.check === 'string' && item.check.trim())
    .map((item) => ({ testName: String(item.testName || '').trim(), check: item.check.trim() }))
}
